/**
 * Created by jane on 17-5-3.
 */


import * as commonConst from '../common/constants';
import * as kecConst from './constants';
import * as kecApis from '../../services/apis/kec';
import Vue from 'vue';
import { EWOULDBLOCK } from 'constants';
import { min } from 'lodash';
export default {

    //查询未绑定状态网卡列表接口
    [kecConst.DescribeUnbindNetworkInterfaces](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, kecApis.DescribeUnbindNetworkInterfaces);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                resolve(data)
            }).catch(e => {
                reject(e);
            });
        });
    },

    //批量绑定动态网卡
    [kecConst.AttachNetworkInterfaces](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, kecApis.AttachNetworkInterfaces);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                resolve(data)
            }).catch(e => {
                reject(e);
            });
        });
    },
    //批量解绑动态网卡
    [kecConst.DetachNetworkInterfaces](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, kecApis.DetachNetworkInterfaces);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                resolve(data);
            }).catch(e => {
                reject(e);
            })
        })
    },

    [kecConst.QueryInstanceNetworkInterfaceQuota](ctx, params) {
        return new Promise ((resolve, reject) => {
            params = _.merge(params, kecApis.QueryInstanceNetworkInterfaceQuota);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                resolve(data)
            }).catch(e => {
                reject(e);
            });
        });
    },
    [kecConst.QueryNetworkResource](ctx, params) {
        return new Promise ((resolve, reject) => {
            params = _.merge(params, kecApis.QueryNetworkResource);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                resolve(data);
            }).catch(e => {
                reject(e);
            })
        });
    },

    [kecConst.DescribeCanMigrateType](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, kecApis.DescribeCanMigrateType);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                resolve(data)
            }).catch(e => {
                reject(e);
            });
        });
    },

    //开启
    [kecConst.StartInstances](ctx, params) {
        return new Promise ((resolve, reject) => {
            params = _.merge(params, kecApis.StartInstances);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                resolve(data)
            }).catch(e => {
                reject(e);
            });
        });
    },
    //关闭,冷重启
    [kecConst.StopInstances](ctx, params) {
        return new Promise ((resolve, reject) => {
            params = _.merge(params, kecApis.StopInstances);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {

                resolve(data)
            }).catch(e => {
                reject(e);
            });
        });
    },
    //重启
    [kecConst.RebootInstances](ctx, params) {
        return new Promise ((resolve, reject) => {
            params = _.merge(params, kecApis.RebootInstances);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                resolve(data);
            }).catch(e => {
                reject(e);
            });
        });
    },
    //重置密码
    [kecConst.ModifyInstancePasswd](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, kecApis.ModifyInstancePasswd);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                if(_.every(_.get(data, 'ResultSet'),(item) => {return item.Return == true })) {

                    resolve(Vue.$trans(`重置密码成功`));
                }else{
                    reject(data);
                }
            }).catch(e => {

                reject(e);
            });
        });
    },
    //创建镜像
    [kecConst.CreateImage](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, kecApis.CreateImage);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                resolve(data);
            }).catch(e => {
                reject(e);
            });
        })
    },
    //从容灾组删除
    [kecConst.RemoveAvoid](ctx, params) {
        return new Promise((resolve, reject) => {

            params = _.merge(params, kecApis.RemoveAvoid);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                resolve(data);
            }).catch(e => {
                reject(e);
            });
        });
    },
    //敏感操作获取
    [kecConst.timeLimit](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, kecApis.timeLimit);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                resolve(data);
            }).catch(e => {
                reject(e);
            });
        });
    },
    //敏感操作设置
    [kecConst.timeSet](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, kecApis.timeSet);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                resolve(data);
            }).catch(e => {
                reject(e);
            });
        });
    },
    //发送验证码
    [kecConst.sendMsg](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, kecApis.sendMsg);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                resolve(data);
            }).catch(e => {
                reject(e);
            });
        });
    },
    //检验验证码
    [kecConst.checkSms](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, kecApis.checkSms);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                resolve(data);
            }).catch(e => {
                reject(e);
            });
        });
    },
    //新价格体系查询单个商品
    [kecConst.QuerySingleKVM](ctx, params) {
        return new Promise ((resolve, reject) => {
            params = _.merge(kecApis.QuerySingleKVM, {params: params});
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                ctx.commit(kecConst.QuerySingleKVM, data);
                resolve(data);
            }).catch(e => {
                reject(e);
            }).then(() => {
                resolve();
            });
        });
    },
    [kecConst.OSImageList](ctx, params) {
        return new Promise ((resolve, reject) => {
            params = _.merge(params, kecApis.OSImageList);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                ctx.commit(kecConst.OSImageList, data);
                resolve(data);
            }).catch(e => {
                reject(e);
            }).then(() => {
                resolve();
            });
        });
    },
    [kecConst.QueryDedicatedHostPackage](ctx, params) {
        return new Promise ((resolve, reject) => {
            params = _.merge(params, kecApis.QueryDedicatedHostPackage);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                ctx.commit(kecConst.QueryDedicatedHostPackage, data);
                resolve();
            }).catch(e => {
                reject(e);
            }).then(() => {
                resolve();
            });
        });
    },
    [kecConst.DedicateList](ctx, params) {
        return new Promise ((resolve, reject) => {
            params = _.merge(params, kecApis.DedicateList);

            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                ctx.commit(kecConst.DedicateList, data);
                resolve(data);
            }).catch(e => {
                reject(e);
            }).then(() => {
                resolve();
            });
        });
    },
    [kecConst.getAvoidList](ctx, params) {
        return new Promise ((resolve, reject) => {
            params = _.merge(params, kecApis.getAvoidList);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                ctx.commit(kecConst.getAvoidList, data);
                resolve();
            }).catch(e => {
                reject(e);
            }).then(() => {
                resolve();
            });
        });
    },
    [kecConst.createAviod](ctx, params) {
        return new Promise ((resolve, reject) => {
            params = _.merge(params, kecApis.createAviod);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                ctx.commit(kecConst.createAviod, data);
                resolve();
            }).catch(e => {
                reject(e);
            }).then(() => {
                resolve();
            });
        });
    },
    [kecConst.QueryEbsPackage](ctx, params) {
        return new Promise ((resolve, reject) => {
            params = _.merge(params, kecApis.QueryEbsPackage);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                ctx.commit(kecConst.QueryEbsPackage, data);
                resolve();
            }).catch(e => {
                reject(e);
            }).then(() => {
                resolve();
            });
        });
    },

    [kecConst.getAvoidPackage](ctx, params) {
        return new Promise ((resolve, reject) => {
            params = _.merge(params, kecApis.getAvoidPackage);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                ctx.commit(kecConst.getAvoidPackage, data);
                resolve();
            }).catch(e => {
                reject(e);
            }).then(() => {
                resolve();
            });
        });
    },

    [kecConst.ImageList](ctx, params) {
        return new Promise ((resolve, reject) => {
            params = _.merge(params, kecApis.ImageList);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                ctx.commit(kecConst.ImageList, data);
                resolve(data);
            }).catch(e => {
                ctx.commit(kecConst.ImageList, {ImagesSet: []});
                reject(e);
            }).then(() => {
                resolve();
            });
        });
    },

    [kecConst.GetInstanceByIds](ctx, params) {
        return new Promise ((resolve, reject) => {
            params = _.merge(params, kecApis.GetInstanceByIds);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                // console.log(data);
                // data.FormedInstanceDataArray[0].InstanceState.Name = 'cold_restart'
                ctx.commit(kecConst.GetInstanceByIds, data);
                resolve(data);
            }).catch(e => {
                reject(e);
            })
        });
    },

    [kecConst.DescribeSecurityGroupList](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, kecApis.DescribeSecurityGroupList);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                resolve(data);
            }).catch(e => {
                reject(e);
            })
        });
    },

    [kecConst.QueryEipPackage](ctx, params) {
        return new Promise ((resolve, reject) => {
            params = _.merge(params, kecApis.QueryEipPackage);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                ctx.commit(kecConst.QueryEipPackage, data);
                resolve();
            }).catch(e => {
                reject(e);
            }).then(() => {
                resolve();
            });
        });
    },

    [kecConst.checkBwsConfig](ctx, params) {
        return new Promise ((resolve, reject) => {
            params = _.merge(params, kecApis.checkBwsConfig);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                ctx.commit(kecConst.checkBwsConfig, data);
                resolve();
            }).catch(e => {
                ctx.commit(kecConst.checkBwsConfig, {result: false});
                reject(e);
            }).then(() => {
                resolve();
            });
        });
    },

    [kecConst.judgeGameUser](ctx, params) {
        return new Promise ((resolve, reject) => {
            params = _.merge(params, kecApis.judgeGameUser);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                ctx.commit(kecConst.judgeGameUser, data);
                resolve(data);
            }).catch(e => {
                reject(e);
            }).then(() => {
                resolve();
            });
        });
    },

    [kecConst.bandwidthList](ctx, params) {
        return new Promise ((resolve, reject) => {
            params = _.merge(params, kecApis.bandwidthList);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                ctx.commit(kecConst.bandwidthList, data);
                resolve();
            }).catch(e => {
                reject(e);
            }).then(() => {
                resolve();
            });
        });
    },

    [kecConst.AllVpcInfo](ctx, params) {
        return new Promise ((resolve, reject) => {
            params = _.merge(kecApis.AllVpcInfo,{params:params});
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                ctx.commit(kecConst.AllVpcInfo, data);
                resolve();
            }).catch(e => {
                reject(e);
            }).then(() => {
                resolve();
            });
        });
    },

    [kecConst.AdrList](ctx, params) {
        return new Promise ((resolve, reject) => {
            params = _.merge(kecApis.AdrList,{params: params});
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                ctx.commit(kecConst.AdrList, data);
                resolve();
            }).catch(e => {
                reject(e);
            }).then(() => {
                resolve();
            });
        });
    },

    [kecConst.DescribePrivateIpAddressAttributes](ctx, params) {
        return new Promise((resolve, reject) => {
            // params = _.merge(kecApis.DescribePrivateIpAddressAttributes, {params: params});
            // params = _.merge(params, kecApis.DescribePrivateIpAddressAttributes);
            params = _.merge(kecApis.DescribePrivateIpAddressAttributes,{params: params});
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                resolve(data)
            }).catch(e => {
                reject(e);
            })
        })
    },
    [kecConst.AllocatedAdrList](ctx, params) {
        return new Promise ((resolve, reject) => {
            params = _.merge(kecApis.AllocatedAdrList,{params: params});
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                ctx.commit(kecConst.AllocatedAdrList, data);
                resolve(data);
            }).catch(e => {
                reject(e);
            });
        });
    },
    [kecConst.DescribeSubnets](ctx, params) {
        return new Promise ((resolve, reject) => {
            params = _.merge(kecApis.DescribeSubnets,{params: params});
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                ctx.commit(kecConst.DescribeSubnets, data);
                resolve(data);
            }).catch(e => {
                reject(e);
            }).then(() => {
                resolve();
            });
        });
    },
    [kecConst.DescribeInstancePrivateIpQuota](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, kecApis.DescribeInstancePrivateIpQuota);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                ctx.commit(kecConst.DescribeInstancePrivateIpQuota, data);
                resolve(data);
            }).catch(e => {
                reject(e);
            }).then(() => {
                resolve();
            });
        });
    },
    //为弹性网卡分配辅助私网ip
    [kecConst.AssignPrivateIpAddress](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, kecApis.AssignPrivateIpAddress);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                ctx.commit(kecConst.AssignPrivateIpAddress, data);
                resolve(data);
            }).catch(e => {
                reject(e);
            }).then(() => {
                resolve();
            });
        });
    },
    //为弹性网卡删除辅助私网ip
    [kecConst.UnAssignPrivateIpAddress](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, kecApis.UnAssignPrivateIpAddress);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                ctx.commit(kecConst.UnAssignPrivateIpAddress, data);
                resolve(data);
            }).catch(e => {
                reject(e);
            }).then(() => {
                resolve();
            });
        });
    },
    [kecConst.OtherCardAssociateAddress](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, kecApis.OtherCardAssociateAddress);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                ctx.commit(kecConst.OtherCardAssociateAddress, data);
                resolve(data);
            }).catch(e => {
                reject(e);
            }).then(() => {
                resolve();
            });
        });
    },
    // [kecConst.QueryQuotaDataByName](ctx, params) {
    //     return new Promise((resolve, reject) => {
    //         params = _.merge(params, kecApis.QueryQuotaDataByName);
    //         ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
    //             ctx.commit(kecConst.QueryQuotaDataByName, data);
    //             resolve(data);
    //         }).catch(e => {
    //             reject(e);
    //         }).then(() => {
    //             resolve();
    //         });
    //     });
    // },
    [kecConst.BatchDisassociateAddress](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, kecApis.BatchDisassociateAddress);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                ctx.commit(kecConst.BatchDisassociateAddress, data);
                resolve(data);
            }).catch(e => {
                reject(e);
            }).then(() => {
                resolve();
            });
        });
    },
    [kecConst.getTagKeysList](ctx, params) {
        return new Promise ((resolve, reject) => {
            params = _.merge(params, kecApis.getTagKeysList);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                ctx.commit(kecConst.getTagKeysList, data);
                resolve();
            }).catch(e => {
                reject(e);
            }).then(() => {
                resolve();
            });
        });
    },
    [kecConst.describeTagValues](ctx, params) {
        return new Promise ((resolve, reject) => {
            params = _.merge(params, kecApis.describeTagValues);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                ctx.commit(kecConst.describeTagValues, data);
                resolve();
            }).catch(e => {
                reject(e);
            }).then(() => {
                resolve();
            });
        });
    },
    [kecConst.calcKvmPrice](ctx, params) {
        return new Promise ((resolve, reject) => {
            params = _.merge(params, kecApis.calcKvmPrice);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                ctx.commit(kecConst.calcKvmPrice, data);
                resolve();
            }).catch(e => {
                reject(e);
            });
        });
    },
    [kecConst.calcAvoidPrice](ctx, params) {
        params = _.merge(params, kecApis.calcAvoidPrice);
        return new Promise ((resolve, reject) => {
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                ctx.commit(kecConst.calcAvoidPrice, data);
                resolve();
            }).catch(e => {
                reject(e);
            }).then(() => {
                resolve();
            });
        });
    },
    [kecConst.updateNetworkConfig](ctx, params) {
        params = _.merge(params, kecApis.updateNetworkConfig);
        return new Promise ((resolve, reject) => {
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                resolve(data);
            }).catch(e => {
                reject(e);
            });
        });
    },
    [kecConst.createProduct](ctx, params) {
        return new Promise ((resolve, reject) => {

            params = _.merge(params, kecApis.createProduct);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                ctx.commit(kecConst.createProduct, data);
                resolve();
            }).catch(e => {
                ctx.commit(kecConst.createProduct, e);
                reject(e);
            });
        });
    },
    [kecConst.calcEipPrice](ctx, params) {
        return new Promise ((resolve, reject) => {
            params = _.merge(params, kecApis.calcEipPrice);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                ctx.commit(kecConst.calcEipPrice, data);
                resolve();
            }).catch(e => {
                reject(e);
            });
        });
    },

    [kecConst.DescribeInstances](ctx, params) {
        return new Promise ((resolve, reject) => {
            params = _.merge(params, kecApis.DescribeInstances);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                ctx.commit(kecConst.DescribeInstances, {
                    list: data.FormedInstanceDataArray,
                    total: data.InstanceCount
                });
                resolve(data);
            }).catch(e => {
                reject(e);
            })
        });
    },
    [kecConst.getAllInstance](ctx, params) {
        return new Promise ((resolve, reject) => {
            params = _.merge(params, kecApis.DescribeInstances);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                resolve(data);
            }).catch(e => {
                reject(e);
            })
        });
    },
    [kecConst.deleteKec](ctx, params) {
        return new Promise ((resolve, reject) => {
            params = _.merge(params, kecApis.deleteKec);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                resolve(data);
            }).catch(e => {
                reject(e);
            })
        });
    },
    [kecConst.getSnapLimitNum](ctx, params) {
        return new Promise ((resolve, reject) => {
            params = _.merge(params, kecApis.getSnapLimitNum);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                resolve(data);
            }).catch(e => {
                reject(e);
            })
        });
    },
    //查询试用权限
    [kecConst.checkTryOrder](ctx, params) {
        return new Promise ((resolve, reject) => {
            params = _.merge(params, kecApis.checkTryOrder);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                if(data.data) {
                    ctx.commit(kecConst.checkTryOrder, data.data);
                    resolve(data);
                } else {
                    reject(data)
                }
            }).catch(e => {
                reject(e);
            })
        });
    },
    [kecConst.getRenewPrice](ctx, params) {
        return new Promise ((resolve, reject) => {
            params = _.merge(params, kecApis.getRenewPrice);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                if(data) {
                    resolve(data);
                } else {
                    reject(data)
                }
            }).catch(e => {
                reject(e);
            })
        });
    },
    [kecConst.tryOrderRenew](ctx, params) {
        return new Promise ((resolve, reject) => {
            params = _.merge(params, kecApis.tryOrderRenew);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                if(data) {
                    resolve(data);
                } else {
                    reject(data)
                }
            }).catch(e => {
                reject(e);
            })
        });
    },
    [kecConst.tryOrderPositive](ctx, params) {
        return new Promise ((resolve, reject) => {
            params = _.merge(params, kecApis.tryOrderPositive);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                if(data) {
                    resolve(data);
                } else {
                    reject(data)
                }
            }).catch(e => {
                reject(e);
            })
        });
    },
    //试用订单的计费方式
    [kecConst.QueryTryBillType](ctx, params) {
        return new Promise ((resolve, reject) => {
            params = _.merge(params, kecApis.QueryTryBillType);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                if(data) {
                    let arrKvm = _.uniq(_.flatten(_.map(data.queryBillTypeByKVMIdList, (o) => {
                        return o.billType
                    })))
                    let arrEip = _.uniq(_.flatten(_.map(data.queryRefBillTypeByEIPIdList, (o) => {
                        return o.billType
                    })))
                    var kecBill = {};
                    _.map(data.queryBillTypeByKVMIdList, (obj) => {
                        _.map(arrKvm, (b, k) => {
                            if (!kecBill[b]) {
                                kecBill[b] = [];
                            }
                            // if (arrKvm[k] == obj.billType[k]) {
                            //     kecBill[b].push(obj.instanceId);
                            // }
                            if(_.indexOf(obj.billType, arrKvm[k]) > -1) {
                                kecBill[b].push(obj.instanceId);
                            }
                        })
                    });
                    var kecDiscount = _.get(data, 'queryBillTypeByKVMIdList[0].discount');
                    var eipBill = {};
                    _.map(data.queryRefBillTypeByEIPIdList, (obj) => {
                        _.map(arrEip, (b, k) => {
                            if (!eipBill[b]) {
                                eipBill[b] = [];
                            }
                            if(_.indexOf(obj.billType, arrEip[k]) > -1) {
                                eipBill[b].push(obj.instanceId);
                            }
                        })
                    })
                    var eipDiscount = _.get(data, 'queryRefBillTypeByEIPIdList[0].discount');
                    ctx.commit(kecConst.QueryTryBillType, {
                          kecBill: kecBill,
                          eipBill: eipBill,
                          kecDiscount: kecDiscount,
                          eipDiscount: eipDiscount
                    });
                    resolve(data);
                } else {
                    reject(data)
                }
            }).catch(e => {
                reject(e);
            })
        });
    },
    //商品续费
    [kecConst.RenewalProduct](ctx, params) {
        return new Promise ((resolve, reject) => {
            params = _.merge(params, kecApis.RenewalProduct);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                if(!_.isEmpty(data.Error)) {
                    reject(e)
                } else {
                    resolve(data);
                }
            }).catch(e => {
                reject(e)
            })
        })
    },
    // 查询通用折扣信息
    [kecConst.queryCommonDiscount](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, kecApis.queryCommonDiscount);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                resolve(data);
            }).catch(e => {
                reject(e);
            });
        });
    },
    // 查询用户折扣
    [kecConst.queryDisCount](ctx, params) {
        return new Promise ((resolve, reject) => {
            params =  _.merge({params: params}, kecApis.queryDisCount);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                let disCountObj  = {};
                if(!_.isEmpty(data.data)) {
                    _.each(data.data, (item) =>{
                        disCountObj[item.product_type_id] = item.rebate;
                    });
                } else {
                    let arr = params.params.ProductTypes.toString().split(',');
                    _.each(arr, (item) => {
                        disCountObj[item] = 1;
                    });
                }
                /*******************************
                //disCountObj[item] = 1表示没有折扣
                ********************************/
                ctx.commit(kecConst.queryDisCount, {
                    disCountObj: disCountObj
                });

                resolve();
            }).catch(e => {
                reject(e);
            })
        })
    },
    // 获取ebs信息
    [kecConst.queryRenewEbsVolumes](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, kecApis.queryRenewEbsVolumes);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                resolve(data);
            }).catch(e => {
                reject(e);
            });
        });
    },
    // 升配
    [kecConst.upgradeKvm](ctx, params) {
        return new Promise ((resolve, reject) => {
            params = _.merge(params, kecApis.upgradeKvm);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                if(!_.isEmpty(data.Error)) {
                    reject(data);
                } else {
                    resolve(data);
                }
            }).catch(e => {
                reject(e)
            })
        })
    },
    // 检查opstate升配
    [kecConst.checkOp](ctx, params) {
        return new Promise ((resolve, reject) => {
            params = _.merge({params: params}, kecApis.checkOp);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                resolve(data);
            }).catch(e => {
                reject(e)
            })
        })
    },
    //获取弹性IP列表
    [kecConst.getEIPList](ctx, params) {
        return new Promise ((resolve, reject) => {
            params = _.merge({params: params}, kecApis.getEIPList);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                resolve(data);
            }).catch(e => {
                reject(e)
            })
        })
    },
    //绑定Eip
    [kecConst.bandEip](ctx, params) {
        return new Promise ((resolve, reject) => {
            params = _.merge({params: params}, kecApis.bandEip);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                resolve(data);
            }).catch(e => {
                reject(e);
            })
        })
    },
    //解绑EIP
    [kecConst.unBandEip](ctx, params) {
        return new Promise ((resolve, reject) => {
            params = _.merge({params: params}, kecApis.unBandEip);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                resolve(data);
            }).catch(e => {
                reject(e);
            })
        })
    },
    //添加标签
    [kecConst.addTags](ctx, params) {
        return new Promise ((resolve, reject) => {
            params = _.merge(params, kecApis.addTags);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                if(data.Return) {
                    resolve(data);
                } else {
                    reject(data.code);
                }
            }).catch(e => {
                reject(e);
            })
        })
    },
    //删除标签
    [kecConst.deleteTag](ctx, params) {
        return new Promise ((resolve, reject) => {
            params = _.merge(params, kecApis.deleteTag);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                resolve(data);
            }).catch(e => {
                reject(e);
            })
        });
    },
    [kecConst.getProjList](ctx, params) {
        return new Promise ((resolve, reject) => {
            params = _.merge(params, kecApis.getProjList);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                ctx.commit(kecConst.getProjList, _.get(data, 'ListProjectResult.ProjectList', []));
                resolve(data);
            }).catch(e => {
                reject(e);
            })
        });
    },
    [kecConst.describeCreateVmType](ctx, params) {
        return new Promise ((resolve, reject) => {
            params = _.merge(params, kecApis.DescribeCreateVmType);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                resolve(data);
            }).catch(e => {
                reject(e);
            })
        });
    },
    // DescribeCreateVmType
    [kecConst.changeProjTo](ctx, params) {
        return new Promise ((resolve, reject) => {
            params = _.merge(params, kecApis.changeProjTo);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                resolve(data);
            }).catch(e => {
                reject(e);
            })
        });
    },
    //更改业务组basic 获取业务组
    [kecConst.getGroupIds](ctx, params) {
        return new Promise ((resolve, reject) => {
            params = _.merge(params, kecApis.getGroupIds);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                resolve(data);
            }).catch(e => {
                reject(e);
            })
        })
    },
    [kecConst.getBasicGroups](ctx, params) {
        return new Promise ((resolve, reject) => {
            params = _.merge(params, kecApis.getBasicGroups);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                resolve(data);
            }).catch(e => {
                reject(e);
            })
        })
    },
    [kecConst.updateGroup](ctx, params) {
        return new Promise ((resolve, reject) => {
            params = _.merge(params, kecApis.updateGroup);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                resolve(data);
            }).catch(e => {
                reject(e);
            })
        })
    },
    [kecConst.createGroup](ctx, params) {
        return new Promise ((resolve, reject) => {
            params = _.merge(params, kecApis.createGroup);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                resolve(data);
            }).catch(e => {
                reject(e);
            })
        })
    },
    [kecConst.updateRelation](ctx, params) {
        return new Promise ((resolve, reject) => {
            params = _.merge(params, kecApis.updateRelation);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                resolve(data);
            }).catch(e => {
                reject(e);
            })
        })
    },

    //挂载辅网卡
    [kecConst.mount](ctx, params) {
        return new Promise ((resolve, reject) => {
            params = _.merge(params, kecApis.mount);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                resolve(data);
            }).catch(e => {
                reject(e);
            })
        })
    },
    [kecConst.batchMountVifs](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, kecApis.batchMountVifs);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                resolve(data);
            }).catch(e => {
                reject(e);
            })
        })
    },

    //卸载辅网卡
    [kecConst.unload](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, kecApis.unload);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                resolve(data);
            }).catch(e => {
                reject(e);
            })
        })
    },
    //降配白名单
    [kecConst.ValidateDowngrade](ctx, params) {
        return new Promise ((resolve, reject) => {
            params = _.merge({params: params}, kecApis.ValidateDowngrade);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                resolve(data);
            }).catch(e => {
                reject(e);
            })
        })
    },
    //修改主机名称
    [kecConst.ModifyInstanceName](ctx, params) {
        return new Promise ((resolve, reject) => {
            params = _.merge({params: params}, kecApis.ModifyInstanceName);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                resolve(data);
            }).catch(e => {
                reject(e);
            })
        })
    },
    //修改网卡名称
    [kecConst.ModifyNetworkInterface](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, kecApis.ModifyNetworkInterface);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                if (data.Return) {
                    resolve(data);
                } else {
                    reject(data);
                }
            }).catch(e => {
                reject(e);
            })
        })
    },
    //旧版防火墙，
    [kecConst.getFirewallList](ctx, params) {
        return new Promise ((resolve, reject) => {
            params = _.merge(params, kecApis.getFirewallList);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                resolve(data);
            }).catch(e => {
                reject(e);
            })
        })
    },
    //防火墙详情
    [kecConst.getFireWallDetail](ctx, params) {
        return new Promise ((resolve, reject) => {
            let p = {};
            p.basePath  = '/console/firewall/detail/' + params.params + '';
            p.method = 'get';
            p.params = {};
            p.params.source = 'kec';
            ctx.dispatch(commonConst.unifiedAjax, p).then(data => {
                resolve(data);
            }).catch(e => {
                reject(e);
            })
        })
    },
    [kecConst.batchEditAttach](ctx, params) {
        return new Promise ((resolve, reject) => {

            params = _.merge(params, kecApis.batchEditAttach);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                resolve(data);
            }).catch(e => {
                reject(e);
            })
        })
    },
    [kecConst.reinstall](ctx, params) {
        return new Promise ((resolve, reject) => {
            params = _.merge(params, kecApis.reinstall);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                resolve(data);
            }).catch(e => {
                reject(e);
            });
        });
    },
    //创建重装系统商品
    [kecConst.ModifyImageProduct](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, kecApis.ModifyImageProduct);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                resolve(data);
            }).catch(e => {
                reject(e);
            });
        });
    },
    //修改DNS名称
    [kecConst.updateDNSName](ctx, params) {
        return new Promise ((resolve, reject) => {
            params = _.merge(params, kecApis.updateDNSName);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                if(data.Return) {
                    resolve(data);
                } else {
                    reject(data);
                }
            }).catch(e => {
                reject(e);
            });
        });
    },

    [kecConst.SearchAllInstances](ctx, params) {
        params = _.merge(params, kecApis.SearchInstances);
        return ctx.dispatch(commonConst.unifiedAjax, params);
    },

    //新的搜素接口
    [kecConst.SearchInstances](ctx, params) {
        return new Promise ((resolve, reject) => {
            params = _.merge(params, kecApis.SearchInstances);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                ctx.commit(kecConst.DescribeInstances, {
                    list: data.FormedInstanceDataArray,
                    total: data.InstanceCount
                });
                resolve(data);
            }).catch(e => {
                reject(e);
            });
        });
    },

    //获取region信息　
    [kecConst.RegionInfos](ctx, params) {
        return new Promise ((resolve, reject) => {
            params = _.merge(params, kecApis.RegionInfos);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                ctx.commit(kecConst.RegionInfos, data);
                resolve(data);
            }).catch(e => {
                reject(e);
            });
        });
    },
    //修改DNS名称
    [kecConst.DescribeInstancesByTagValue](ctx, params) {
        return new Promise ((resolve, reject) => {
            params = _.merge(params, kecApis.DescribeInstancesByTagValue);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                resolve(data);
            }).catch(e => {
                reject(e);
            });
        });
    },
    //-预约升配预迁移失败更新状态
    [kecConst.MigrateUpgradeResetState](ctx, params) {
        return new Promise ((resolve, reject) => {
            params = _.merge(params, kecApis.MigrateUpgradeResetState);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                resolve(data);
            }).catch(e => {
                reject(e);
            });
        });
    },
    //-恢复绑定和解绑失败状态
    [kecConst.RecoveryDetachKeyOrAttachKeyState](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, kecApis.RecoveryDetachKeyOrAttachKeyState);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                resolve(data);
            }).catch(e => {
                reject(e);
            });
        });
    },
    //-变更实例类型 排队中 可以取消
    [kecConst.CancelCrossInstanceMigrate](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, kecApis.CancelCrossInstanceMigrate);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                resolve(data);
            }).catch(e => {
                reject(e);
            });
        });
    },

    [kecConst.QueryProductGroups](ctx, params) {
        return new Promise ((resolve, reject) => {
            params = _.merge(params, kecApis.QueryProductGroups);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                ctx.commit(kecConst.QueryProductGroups, data);
                resolve(data);
            }).catch(e => {
                reject(e);
            });
        });
    },

    [kecConst.Getlines](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, kecApis.Getlines);
            ctx.dispatch(commonConst.unifiedAjax, params).then(req => {
                ctx.commit(kecConst.Getlines, req);
                resolve(req);
            }).catch(e => {
                reject(e);
            });
        });
    },

    [kecConst.instanceMigrate](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, kecApis.instanceMigrate);
            ctx.dispatch(commonConst.unifiedAjax, params).then(req => {
                // ctx.commit(kecConst.instanceMigrate, req);
                resolve(req);
            }).catch(e => {
                reject(e);
            });
        });
    },
    //获取镜像市场tab列表
    [kecConst.describeMarketTAbList](ctx, params) {
        return new Promise ((resolve, reject) => {
            params = _.merge({params:params}, kecApis.describeMarketTAbList);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                resolve(data);
            }).catch(e => {
                reject(e);
            });
        });
    },
    //获取镜像市场镜像
    [kecConst.describeMarketImage](ctx, params) {
        return new Promise ((resolve, reject) => {
            params = _.merge(params, kecApis.describeMarketImage);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                resolve(data);
            }).catch(e => {
                reject(e);
            });
        });
    },

    [kecConst.attachKey](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, sshApis.apiAttachKey);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                ctx.commit(sshConst.attachKey, data);
                resolve();
            }).catch(e => {
                reject(e);
            })
        });
    },

    // 创建升配商品支持批量
    [kecConst.ModifyInstanceTypeProduct](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, kecApis.ModifyInstanceTypeProduct);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                if (!_.isEmpty(data.Error)) {
                    reject(data);
                } else {
                    resolve(data);
                }
            }).catch(e => {
                reject(e)
            })
        })
    },

    // 修改显示设置 支持批量
    [kecConst.ModifyInstanceScreenResolution](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, kecApis.ModifyInstanceScreenResolution);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                if (!_.isEmpty(data.Error)) {
                    reject(data);
                } else {
                    resolve(data);
                }
            }).catch(e => {
                reject(e)
            })
        })
    },

    // 实例绑定/修改IAM角色）支持批量
    [kecConst.AttachInstancesIamRole](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, kecApis.AttachInstancesIamRole);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                resolve(data);
            }).catch(e => {
                reject(e)
            })
        })
    },

    // 实例解绑IAM角色支持批量
    [kecConst.DetachInstancesIamRole](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, kecApis.DetachInstancesIamRole);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                resolve(data);
            }).catch(e => {
                reject(e)
            })
        })
    },

    // 获取kec服务下所有IAM角色列表
    [kecConst.DescribeKecIamRoles](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, kecApis.DescribeKecIamRoles);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                resolve(data);
            }).catch(e => {
                reject(e)
            })
        })
    },

    //主机加入容灾
    [kecConst.createAvoid](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, kecApis.createAvoid);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                // ctx.commit(kecConst.createAvoid, data);
                resolve(data);
            }).catch(e => {
                reject(e);
            })
        });
    },

    [kecConst.DescribeOverView](ctx, params) {
        return new Promise ((resolve, reject) => {
            params = _.merge(params, kecApis.DescribeOverView);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                if(data.code == 200){
                    ctx.commit(kecConst.DescribeOverView, data.ResourceList);
                    resolve(data);
                }else{
                    reject(data)
                }
            }).catch(e => {
                reject(e);
            });
        });
    },

    //获取主机可挂载的ebs盘列表
    [kecConst.DescribeAvailableVolumes](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, kecApis.DescribeAvailableVolumes);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                ctx.commit(kecConst.DescribeAvailableVolumes, data);
                resolve(data);
            }).catch(e => {
                reject(e);
            })
        });
    },

    //获取主机绑定的ebs盘列表
    [kecConst.DescribeInstanceVolumes](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, kecApis.DescribeInstanceVolumes);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                ctx.commit(kecConst.DescribeInstanceVolumes, data);
                resolve(data);
            }).catch(e => {
                reject(e);
            })
        });
    },

    //主机挂载EBS盘
    [kecConst.AttachVolume](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, kecApis.AttachVolume);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                resolve(data);
            }).catch(e => {
                reject(e);
            })
        });
    },

    //主机卸载EBS盘
    [kecConst.DetachVolume](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, kecApis.DetachVolume);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                ctx.commit(kecConst.DetachVolume, data);
                resolve(data);
            }).catch(e => {
                reject(e);
            })
        });
    },

    //获取kvm列表
    [kecConst.queryKvmList](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, kecApis.queryKvmList);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                resolve(data);
            }).catch(e => {
                reject(e);
            });
        });
    },

    //创建实例启动模板
    [kecConst.createModel](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, kecApis.createModel);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                // ctx.commit(kecConst.createModel, data);
                resolve(data);
            }).catch(e => {
                // ctx.commit(kecConst.createModel, e);
                reject(e);
            });
        });
    },
    //创建实例启动模板版本
    [kecConst.CreateVersion](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, kecApis.CreateVersion);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                resolve(data);
            }).catch(e => {
                reject(e);
            });
        });
    },
    //修改实例启动模板
    [kecConst.modifyModel](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, kecApis.modifyModel);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                // ctx.commit(kecConst.modifyModel, data);
                resolve(data);
            }).catch(e => {
                ctx.commit(kecConst.modifyModel, e);
                reject(e);
            });
        });
    },

    //创建预留实例券商品
    [kecConst.createResProduct](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, kecApis.createResProduct);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                resolve(data);
            }).catch(e => {
                ctx.commit(kecConst.createResProduct, e);
                reject(e);
            });
        });
    },

    [kecConst.batchinstanceMigrate](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, kecApis.batchinstanceMigrate);
            ctx.dispatch(commonConst.unifiedAjax, params).then(req => {
                resolve(req);
            }).catch(e => {
                ctx.commit(kecConst.getTimeddelDate, e);
                reject(e);
            });
        });
    },
    // 定时删除获取服务器时间
    [kecConst.getTimeddelDate](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, kecApis.getTimeddelDate);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                // ctx.commit(kecConst.modifyModel, data);
                resolve(data);
            }).catch(e => {
                ctx.commit(kecConst.getTimeddelDate, e);
                reject(e);
            });
        });
    },

    [kecConst.editTimeddelDate](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, kecApis.editTimeddelDate);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                // ctx.commit(kecConst.modifyModel, data);
                resolve(data);
            }).catch(e => {
                ctx.commit(kecConst.editTimeddelDate, e);
                reject(e);
            });
        });
    },

    //分配IPV6地址
    [kecConst.distributeIpv6](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, kecApis.distributeIpv6);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                resolve(data);
            }).catch(e => {
                reject(e);
            });
        });
    },

    [kecConst.ValidateIpv6Support](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, kecApis.ValidateIpv6Support);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                resolve(data);
            }).catch(e => {
                reject(e);
            });
        });
    },

    //实例详情页需要获取IPV6 白名单效验
    [kecConst.distributeIpv6Verification](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, kecApis.distributeIpv6Verification);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                resolve(data);
            }).catch(e => {
                reject(e);
            });
        });
    },

    //获取支持IPV6的机型ProductTypeId的数据
    [kecConst.getIpv6SupportProductType](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, kecApis.getIpv6SupportProductType);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                resolve(data);
            }).catch(e => {
                reject(e);
            });
        });
    },

    //变更实例类型 白名单效验
    [kecConst.changeTypeValidWhitelist](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, kecApis.changeTypeValidWhitelist);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                resolve(data);
            }).catch(e => {
                reject(e);
            });
        });
    },

    //镜像预热 白名单效验
    [kecConst.preheatingValidWhitelist](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge({
                params: params
            }, kecApis.preheatingValidWhitelist);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                resolve(data);
            }).catch(e => {
                reject(e);
            });
        });
    },
    //--以下为未登录actions--
    [kecConst.noLoginCalcEipPrice](ctx, params) {
        return new Promise ((resolve, reject) => {
            params = _.merge(params, kecApis.noLoginCalcEipPrice);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                ctx.commit(kecConst.noLoginCalcEipPrice, data);
                resolve();
            }).catch(e => {
                reject(e);
            });
        });
    },
    [kecConst.noLoginCalcKvmPrice](ctx, params) {
        return new Promise ((resolve, reject) => {
            params = _.merge(params, kecApis.noLoginCalcKvmPrice);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                ctx.commit(kecConst.noLoginCalcKvmPrice, data);
                resolve();
            }).catch(e => {
                reject(e);
            });
        });
    },
    [kecConst.noLoginQueryNetworkResource](ctx, params) {
        return new Promise ((resolve, reject) => {
            params = _.merge(params, kecApis.noLoginQueryNetworkResource);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                resolve(data);
            }).catch(e => {
                reject(e);
            })
        });
    },
    [kecConst.noLoginCreateProduct](ctx, params) {
        return new Promise ((resolve, reject) => {
            params = _.merge(params, kecApis.noLoginCreateProduct);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                ctx.commit(kecConst.noLoginCreateProduct, data);
                resolve();
            }).catch(e => {
                ctx.commit(kecConst.noLoginCreateProduct, e);
                reject(e);
            });
        });
    },
    //--以上为未登录actions--

    //概览页获取产品线动态
    [kecConst.DescribeUpdateInfos](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, kecApis.DescribeUpdateInfos);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                ctx.commit(kecConst.DescribeUpdateInfos, data);
                resolve(data);
            }).catch(e => {
                reject(e);
            });
        });
    },
    [kecConst.QueryAttachSystemDiskVolume](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, kecApis.QueryAttachSystemDiskVolume);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                resolve(data);
            }).catch(e => {
                reject(e);
            });
        });
    },
    [kecConst.AttachSystemDiskVolume](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, kecApis.AttachSystemDiskVolume);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                resolve(data);
            }).catch(e => {
                reject(e);
            });
        });
    },
    //创建预迁移
    [kecConst.PreMigrateInstance](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, kecApis.PreMigrateInstance);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                resolve(data);
            }).catch(e => {
                reject(e);
            });
        });
    },
    //取消创建预迁移
    [kecConst.CancelPreMigrateInstance](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, kecApis.CancelPreMigrateInstance);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                resolve(data);
            }).catch(e => {
                reject(e);
            });
        });
    },
    [kecConst.QueryQuotaDataByName](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, kecApis.QueryQuotaDataByName);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                // ctx.commit(kecConst.QueryQuotaDataByName, data);
                resolve(data);
            }).catch(e => {
                reject(e);
            }).then(() => {
                resolve();
            });
        });
    },
    //获取剩余可开小套餐数量
    [kecConst.DescribeMinFlavorCount](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, kecApis.DescribeMinFlavorCount);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                resolve(data);
            }).catch(e => {
                reject(e);
            });
        });
    },
    //获取项目制最大可查询数量
    [kecConst.DescribeProjectMaxNum](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, kecApis.DescribeProjectMaxNum);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                resolve(data);
            }).catch(e => {
                reject(e);
            });
        });
    },
    //创建定时预迁移
    [kecConst.ModifyInstanceAutoPreMigrateTime](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, kecApis.ModifyInstanceAutoPreMigrateTime);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                resolve(data);
            }).catch(e => {
                reject(e);
            });
        });
    },
    
    //取消定时预迁移
    [kecConst.CancelInstanceAutoPreMigrateTime](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, kecApis.CancelInstanceAutoPreMigrateTime);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                resolve(data);
            }).catch(e => {
                reject(e);
            });
        });
    },

    //获取实例系统盘信息
    [kecConst.DescribeInstanceSystemVolume](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, kecApis.DescribeInstanceSystemVolume);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                resolve(data);
            }).catch(e => {
                reject(e);
            });
        });
    },
    //获取某个VPC下所有的安全组
    [kecConst.SecurityGroupVpcInfo](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, kecApis.SecurityGroupVpcInfo);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                resolve(data);
            }).catch(e => {
                reject(e);
            });
        });
    },
    //获取可绑定的安全组最大值
    [kecConst.DescribeSecurityGroupsQuota](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, kecApis.DescribeSecurityGroupsQuota);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                resolve(data);
            }).catch(e => {
                reject(e);
            });
        });
    },
    //设置资源保护开关
    [kecConst.SetInstanceResourceProtect](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, kecApis.SetInstanceResourceProtect);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                resolve(data);
            }).catch(e => {
                reject(e);
            });
        });
    },
    [kecConst.QueryProductNetworkInterfaceQuota](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, kecApis.QueryProductNetworkInterfaceQuota);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                resolve(data);
            }).catch(e => {
                reject(e);
            });
        });
    },

    // 获取ebs盘的吞吐量和IOPS
    [kecConst.DescribeEbsPerfQuotas](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, kecApis.DescribeEbsPerfQuotas);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                resolve(data);
            }).catch(e => {
                reject(e);
            });
        });
    },
    
    // 查询专属集群信息
    [kecConst.DescribeDedicatedBlockStorageClusters](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, kecApis.DescribeDedicatedBlockStorageClusters);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                resolve(data);
            }).catch(e => {
                reject(e);
            });
        });
    },

    // 查询用户计费类型
    [kecConst.DescribeVmUserBillType](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, kecApis.DescribeVmUserBillType);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                resolve(data);
            }).catch(e => {
                reject(e);
            });
        });
    },

    // 查看待生效的更改计费类型任务
    [kecConst.DescribeBatchBillTypeChangeTasks](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, kecApis.DescribeBatchBillTypeChangeTasks);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                resolve(data);
            }).catch(e => {
                reject(e);
            });
        });
    },

    // 提交转计费类型任务
    [kecConst.BatchUpgradeInstanceChargeType](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, kecApis.BatchUpgradeInstanceChargeType);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                resolve(data);
            }).catch(e => {
                reject(e);
            });
        });
    },
    // 批量请求价格
    [kecConst.BatchUpgradeCalculateKVMPrice](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, kecApis.BatchUpgradeCalculateKVMPrice);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                resolve(data);
            }).catch(e => {
                reject(e);
            });
        });
    },
    // 获取ESSD_PLX系统盘类型的容量范围
    [kecConst.DescribeSystemDiskSizeRange](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, kecApis.DescribeSystemDiskSizeRange);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                let res = {}
                if(data?.data?.systemDiskRangeList?.length){
                    data.data.systemDiskRangeList.forEach(item => {
                        res[item.systemDiskType] = {
                            min: item.range.minSize || 0,
                            max: item.range.maxSize || 0,
                            step: item.range.stepSize || 1,
                        };
                    })
                }
                resolve(res);
            }).catch(e => {
                reject(e);
            });
        });
    },
    //获取主机可挂载的ebs盘列表, 新接口，支持分页和搜索查询
    [kecConst.DescribeAvailableVolumesV2](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, kecApis.DescribeAvailableVolumesV2);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                resolve(data);
            }).catch(e => {
                reject(e);
            })
        });
    },
    //查询支持共享云盘的机型
    [kecConst.DescribeMultiAttachInstanceType](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, kecApis.DescribeMultiAttachInstanceType);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                resolve(data);
            }).catch(e => {
                reject(e);
            })
        });
    },
    // 定时转正
    [kecConst.ScheduleTrialToBuy](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, kecApis.ScheduleTrialToBuy);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                resolve(data);
            }).catch(e => {
                reject(e);
            });
        });
    },
    // 取消定时转正
    [kecConst.CancelScheduleTrialToBuy](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, kecApis.CancelScheduleTrialToBuy);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                resolve(data);
            }).catch(e => {
                reject(e);
            });
        });
    },
    // 查询定时转正
    [kecConst.QueryScheduleTrialToBuy](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, kecApis.QueryScheduleTrialToBuy);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                resolve(data);
            }).catch(e => {
                reject(e);
            });
        });
    },
}
